// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__11d0a","footer":"Form_footer__ArTPu"};